import React from "react";
import {
	PairedLocatedVelavuDevice,
	VelavuGeofence,
	VelavuSite,
} from "velavu-js-api";
import AssetList from "../asset-list/asset-list";
import GeofenceList from "../geofence-list/geofence-list";
import PinnedList from "../pinned-list";
import SiteList from "../site-list/site-list";
import { MapListDisplayType } from "./map-list-display-type";
import MapListSelector from "./map-list-selector";
import FloorFilter from "../../../../data/floor-filter";

export interface MapListProps {
	displayType: MapListDisplayType;
	onChangeDisplayType: (displayType: MapListDisplayType) => void;

	selectedFloorNum: number | undefined;
	onChangeFloorFilter: (filter: FloorFilter) => void;
	showFloorFilter: boolean;

	onClose?: () => void;

	devices: PairedLocatedVelavuDevice[];
	onSelectDevice: (deviceID: string) => void;
	onHoverDevice: (deviceID: string | undefined) => void;

	sites: VelavuSite[];
	onSelectSite: (siteID: string) => void;
	onCreateSite: () => void;

	geofences: VelavuGeofence[];
	onSelectGeofence: (geofenceID: string) => void;
	onHoverGeofence: (geofenceID: string | undefined) => void;
	onCreateGeofence: () => void;
}

export function MapList(props: MapListProps) {
	return (
		<PinnedList>
			<MapListSelector
				displayType={props.displayType}
				onChangeDisplayType={props.onChangeDisplayType}
				onClose={props.onClose}
			/>

			{props.displayType === MapListDisplayType.Asset && (
				<AssetList
					devices={props.devices}
					onSelectDevice={props.onSelectDevice}
					onHoverDevice={props.onHoverDevice}
					selectedFloorNum={props.selectedFloorNum}
					onChangeFloorFilter={props.onChangeFloorFilter}
					showFloorFilter={props.showFloorFilter}
				/>
			)}

			{props.displayType === MapListDisplayType.Site && (
				<SiteList
					sites={props.sites}
					onSelectSite={props.onSelectSite}
					onCreateSite={props.onCreateSite}
				/>
			)}

			{props.displayType === MapListDisplayType.Geofence && (
				<GeofenceList
					geofences={props.geofences}
					onSelectGeofence={props.onSelectGeofence}
					onHoverGeofence={props.onHoverGeofence}
					onCreateGeofence={props.onCreateGeofence}
				/>
			)}
		</PinnedList>
	);
}
